module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAq0lEQVR4Ae3VHwxCURiG8WdtF5IrbUl8MUhzuBzllkMu5ZJjEueQBmEctSRqq7U36fMr73bP9j3H99vOv49el2VZpv/qUs3eCcy5IRdQseGLXEDDGSEXsOKFXMCII0IuoOWOXMCQHUIuYMoVuYABa97IBUw4IeQCFjyRE1gGUOwWxSF/XEA0i2ta6EOLWh5eAMbx2RX6XUcNFy8AFdsYmUUO/ajmQJZlWY/7AdnUKuYs2CeYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_skip_previous_black_24dp.png
// module id = 125
// module chunks = 0